import { useEffect, useRef, useState } from 'react';
import storeData from '../data/store';
import { useLanguage } from '../context/LanguageContext';
import type { StoreProduct } from '../types';

const store = storeData as { privatePaymentLink: string; products: StoreProduct[] };
const isStripe = (value?: string) => Boolean(value && /^https:\/\/(buy\.stripe\.com|checkout\.stripe\.com)\//i.test(value));

export function ProductGrid() {
  const { local, t } = useLanguage();
  const [selected, setSelected] = useState<StoreProduct | null>(null);
  const dialog = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    if (selected) dialog.current?.showModal();
    else if (dialog.current?.open) dialog.current.close();
  }, [selected]);
  return <>
    <div aria-live="polite" className="product-grid" id="product-grid">
      {store.products.map(product => <article className="shop-card" key={product.id}>
        <button className="shop-image" type="button" aria-label={local(product.title) || ''} onClick={() => setSelected(product)}>
          <img src={`/${product.image}`} alt={local(product.title) || ''} loading="lazy" />
        </button>
        <div className="shop-card-copy">
          <p className="product-status">{local(product.status)}</p><h3>{local(product.title)}</h3><p className="product-price">{local(product.price)}</p>
          <button className="text-button" type="button" onClick={() => setSelected(product)}>{t('viewDetails','View Details')}</button>
        </div>
      </article>)}
    </div>
    <dialog className="product-dialog" ref={dialog} onCancel={() => setSelected(null)} onClick={e => { if (e.target === dialog.current) setSelected(null); }}>
      <button className="dialog-close" type="button" onClick={() => setSelected(null)}>{t('close','Close')}</button>
      {selected && <div className="product-dialog-grid">
        <div className="product-dialog-image"><img src={`/${selected.image}`} alt={local(selected.title) || ''} /></div>
        <div className="product-dialog-copy">
          <p className="eyebrow product-dialog-status">{local(selected.status)}</p><h2 className="product-dialog-title">{local(selected.title)}</h2>
          <p className="product-dialog-description">{local(selected.description)}</p>
          <dl><div><dt>{t('availability','Availability')}</dt><dd>{local(selected.availability)}</dd></div><div><dt>{t('price','Price')}</dt><dd>{local(selected.price)}</dd></div></dl>
          {isStripe(selected.paymentLink)
            ? <a className="button" href={selected.paymentLink} rel="noopener noreferrer" target="_blank">{t('buyNow','Continue to Checkout')}</a>
            : <a className="button" href={`/private-enquiry.html?product=${encodeURIComponent(local(selected.title) || '')}`}>{t('requestQuote','Request a Private Quotation')}</a>}
        </div>
      </div>}
    </dialog>
  </>;
}
